import { Component, Inject, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup } from '@angular/forms';
import { brand } from 'src/app/models/brand';
import { Category } from 'src/app/models/category';
interface FilterData {
  brands: brand[];
  [key: string]: unknown[];
}

interface CurrentFilters {
  brands: string[];
  [key: string]: unknown;
}

@Component({
  selector: 'megastore-admin-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss']
})
export class FiltersComponent {

  public dataArray: Array<[string, unknown[]]> = [];
  public filterForm: FormGroup;
  public hasActiveFilters = false;
  public categories: Array<Category> = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      data: FilterData,
      currentFilters?: CurrentFilters
    },
    private dialogRef: MatDialogRef<FiltersComponent>,
    private fb: FormBuilder
  ) {
    this.dataArray = Object.entries(data.data);
    this.categories = data.data['categories'] as Array<Category>;
    // Initialize form with current filters if they exist
    const initialBrands = data.currentFilters?.brands || [];
    const initialCategories = (data.currentFilters?.['categories'] || []) as unknown[];
    this.hasActiveFilters = initialBrands.length > 0 || initialCategories.length > 0;
    
    this.filterForm = this.fb.group({
      brands: [initialBrands],
      categories: [initialCategories]
    });
  }

  getBrandsFromItem(item: [string, unknown[]]): brand[] {
    return item[0] === 'brands' ? item[1] as brand[] : [];
  }

  applyFilters(): void {
    this.dialogRef.close(this.filterForm.value);
  }

  clearFilters(): void {
    this.filterForm.reset({
      brands: [],
      categories: []
    });
    this.hasActiveFilters = false;
  }

  cancelDialog(): void {
    this.dialogRef.close();
  }
}
